import * as React from 'react';
import './index.css';
import { RichText } from '@wmfe/mach-pro-components-react';
import { highlightListForText } from '@/common/Highlight';

interface IState {}

interface Props {
  model: any;
}

export default class DiscountBarItemView extends React.Component<Props, IState> {
// {
  //   "bgColor": "#999999",
  //   "orderBgColor": "#999999",
  //   "orderTagIcon": "http://img-ap-hongkong.mykeeta.net/picturesupload/52ca3dd1a7bae9094b6417ae970098a33994.png",
  //   "richText": "滿$10享<highlight>2</highlight>折",
  //   "orderTitle": "立即選購",
  //   "text": "滿$10享2折"
  // }

  render() {
    const { model } = this.props;
    const data = model.originalData?.discountBar || {};

    const bgColor = data?.bgColor;
    const orderBgColor = data?.orderBgColor;
    const orderTagIcon = data?.orderTagIcon;
    const richText = data?.richText;
    const orderTitle = data?.orderTitle;

    const richTextContents: any = highlightListForText(richText).map((item) => ({
      type: 'text',
      text: item.text,
      fontSize: item.highlight ? 24 : 12,
      color: '#D90012',
      fontFamily: 'KeeTa-Bold'
    }));

    return (
      <view className="container">
        <view className="content-area" style={{ backgroundColor: bgColor }}>
          <view className="left-area">
            <view className="left-text-wrapper">
              <RichText className="left-text" content={richTextContents} />
            </view>
          </view>
          <view className="right-area">
            <view className="right-area-container">
              <view className="right-text-wrapper" style={{ backgroundColor: orderBgColor }}>
                <text className="right-text" content={orderTitle} />
              </view>
              <view className="right-icon-image-wrapper">
                <image className="right-icon-image" src={orderTagIcon} />
              </view>
            </view>
          </view>
        </view>
      </view>
    );
  }
}
